import createRequestOptions from './createRequestOptions';
import processRequest from './processRequest';

export default function createApi(globalOptions = {}) {
  globalOptions = { cmap: {}, ...globalOptions };

  return async (reqOptions) => {
    const start = new Date();

    const options = createRequestOptions(globalOptions, reqOptions);
    const { cmap, getIdenticalRequestText, id, pb, provider } = options;

    if (cmap[id]) {
      cmap[id](getIdenticalRequestText(options));
    }

    cmap[id] = provider.cancel;

    if (!pb.status()) {
      pb.start();
    }

    const res = await processRequest(options);

    delete cmap[id];

    if (!Object.keys(cmap).length) {
      pb.done();
    }

    if (res.error) {
      throw res;
    }

    res.elapsed = new Date() - start;

    return res;
  };
}
